import { render, staticRenderFns } from "./CoachProfile.vue?vue&type=template&id=44fcb3ee&scoped=true"
import script from "./CoachProfile.vue?vue&type=script&lang=js"
export * from "./CoachProfile.vue?vue&type=script&lang=js"
import style0 from "./CoachProfile.vue?vue&type=style&index=0&id=44fcb3ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fcb3ee",
  null
  
)

export default component.exports